import React, { MutableRefObject } from 'react';

import IconTypes from 'components/Icon/IconTypes';
import {
  InputIcon,
  InputLabelTextWrapper,
  InputTag,
  InputTextTag,
  InputWrapper,
} from './styles';
import { black } from 'utils/style/colors';

interface IInputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  forwardRef?:
    | ((instance: HTMLInputElement | null) => void)
    | React.RefObject<HTMLInputElement>
    | MutableRefObject<HTMLInputElement | undefined>
    | null;
  id: string;
  icon?: IconTypes;
  label?: string | React.ReactNode;
  labelStyle?: any;
  loading?: boolean;
  type: 'text' | 'checkbox' | 'radio' | 'email' | 'number' | 'password' | 'tel';
  wrapperClassName?: string;
  wrapperStyle?: any;
  backgroundColor?: any;
}

const Input: React.FC<IInputProps> = ({
  id,
  type,
  icon,
  label,
  wrapperClassName,
  labelStyle,
  forwardRef,
  wrapperStyle,
  ...restProps
}) => {
  if (type === 'checkbox' || type === 'radio') {
    return (
      <div className={wrapperClassName} style={wrapperStyle}>
        <InputTag id={id} type={type} ref={forwardRef as any} {...restProps} />
        <label style={labelStyle} htmlFor={id}>
          {label}
        </label>
      </div>
    );
  }

  if (
    type === 'email' ||
    type === 'password' ||
    type === 'tel' ||
    type === 'number'
  ) {
    return (
      <div className={wrapperClassName} style={wrapperStyle}>
        {label && (
          <label style={{ color: black, ...labelStyle }} htmlFor={id}>
            {label}
          </label>
        )}
        <InputWrapper>
          <InputTag
            id={id}
            ref={forwardRef as any}
            type={type}
            hasIcon={!!icon}
            onWheel={(e: WheelEvent) => {
              if (
                type === 'number' &&
                document.activeElement === e.currentTarget
              ) {
                (e.currentTarget as HTMLInputElement)?.blur();
                e.preventDefault();
              }
            }}
            {...restProps}
          />
          {icon && <InputIcon type={icon} />}
        </InputWrapper>
      </div>
    );
  }

  if (type === 'text') {
    return (
      <InputLabelTextWrapper className={wrapperClassName} style={wrapperStyle}>
        {label && (
          <label style={{ color: black, ...labelStyle }} htmlFor={id}>
            {label}
          </label>
        )}
        <InputWrapper>
          <InputTextTag
            id={id}
            ref={forwardRef as any}
            type={type}
            hasIcon={!!icon}
            {...restProps}
          />
          {icon && <InputIcon type={icon} />}
        </InputWrapper>
      </InputLabelTextWrapper>
    );
  }

  return null;
};

export default React.memo(Input);
